"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContent = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@emotion/react");
const buildInAnimation = (animation) => `${(0, react_2.keyframes)(animation)} 360ms forwards`;
const buildOutAnimation = (animation) => `${(0, react_2.keyframes)(animation)} 250ms forwards`;
const borderRadius = {
    small: "10px"
};
const DrawerContent = ({ children, placement = 'bottom', size = 'xs', open, animation = 'slide', }) => {
    const sizes = {
        xs: '20rem',
        sm: '24rem',
        md: '28rem',
        lg: '32rem',
        xl: '36rem',
        full: '100%',
    }[size];
    const placementStyles = {
        top: {
            transform: animation === 'slide' && 'translate3d(0,-100%,0)',
            width: '100%',
            height: sizes,
            top: 0,
            bottom: 'auto',
            borderBottomLeftRadius: borderRadius.small,
            borderBottomRightRadius: borderRadius.small,
        },
        right: {
            top: '0',
            transform: animation === 'slide' && 'translate3d(100%,0,0)',
            right: 0,
            width: sizes,
            height: '100%',
            borderTopLeftRadius: borderRadius.small,
            borderBottomLeftRadius: borderRadius.small,
        },
        bottom: {
            transform: animation === 'slide' && 'translate3d(0,100%,0)',
            width: '100%',
            height: sizes,
            bottom: 0,
            top: 'auto',
            borderTopLeftRadius: borderRadius.small,
            borderTopRightRadius: borderRadius.small,
        },
        left: {
            top: 0,
            transform: animation === 'slide' && 'translate3d(0%,0,0)',
            left: 0,
            width: sizes,
            height: '100%',
            borderTopRightRadius: borderRadius.small,
            borderBottomRightRadius: borderRadius.small,
        },
    }[placement];
    const animations = {
        slide: {
            top: {
                in: {
                    from: { transform: 'translate3d(0,-100%,0)' },
                    to: { transform: 'translate3d(0,0,0)' },
                },
                out: {
                    from: { transform: 'translate3d(0,0,0)' },
                    to: { transform: 'translate3d(0,-100%,0)' },
                },
            },
            right: {
                in: {
                    from: { transform: 'translate3d(100%,0,0)' },
                    to: { transform: 'translate3d(0,0,0)' },
                },
                out: {
                    from: { transform: 'translate3d(0,0,0)' },
                    to: { transform: 'translate3d(100%,0,0)' },
                },
            },
            bottom: {
                in: {
                    from: { transform: 'translate3d(0,100%,0)' },
                    to: { transform: 'translate3d(0,0,0)' },
                },
                out: {
                    from: { transform: 'translate3d(0,0,0)' },
                    to: { transform: 'translate3d(0,100%,0)' },
                },
            },
            left: {
                in: {
                    from: { transform: 'translate3d(-100%,0,0)' },
                    to: { transform: 'translate3d(0,0,0)' },
                },
                out: {
                    from: { transform: 'translate3d(0,0,0)' },
                    to: { transform: 'translate3d(-100%,0,0)' },
                },
            },
        },
        fade: {
            ...Object.fromEntries(['top', 'bottom', 'left', 'right'].map(key => [key, {
                    in: {
                        from: { opacity: '0' },
                        to: { opacity: '1' },
                    },
                    out: {
                        from: { opacity: '1' },
                        to: { opacity: '0' },
                    },
                }])),
        },
    }[animation];
    const animationStylesIn = animations[placement]["in"];
    const animationStylesOut = animations[placement]['out'];
    return (react_1.default.createElement(react_2.ClassNames, null, ({ css }) => (react_1.default.createElement("div", { "data-state": open ? "open" : "closed", className: css({
            ...placementStyles,
            backgroundColor: '#222',
            boxShadow: '0 10px 15px #0007',
            position: 'fixed',
            maxWidth: '100%',
            maxHeight: '100%',
            zIndex: 2000,
            '&[data-state="open"]': {
                animation: 'slideRightIn 360ms forwards',
                //...Object.fromEntries(Object.entries(animationStylesIn).map(([query, animation]) => [query, { animation: buildInAnimation(animation) }])),
            },
            '&[data-state="closed"]': {
                animation: 'slideRightOut 360ms forwards',
                //...Object.fromEntries(Object.entries(animationStylesOut).map(([query, animation]) => [query, { animation: buildOutAnimation(animation) }])),
            },
        }) }, children))));
};
exports.DrawerContent = DrawerContent;
//# sourceMappingURL=index.js.map